/**
 * Single source of truth for every price, plan and product count shown on the
 * website. Approved U.S. pricing: a monthly plan and a yearly plan. There is no
 * weekly-billed plan and no free subscription trial; the free in-browser
 * sample lesson is separate.
 */
export const pricing = {
  monthlyPrice: '$11.99',
  monthlyPeriod: 'per month',
  monthlyBilling: 'Billed monthly. Charged every month.',
  /** Approximate equivalent only ($11.99 × 12 ÷ 52). Not a weekly charge. */
  monthlyWeeklyEquivalent: '$2.77',
  annualPrice: '$69.99',
  annualPeriod: 'per year',
  annualBilling: 'Billed yearly. The full $69.99 is charged upfront when you subscribe.',
  /** Approximate equivalent only ($69.99 ÷ 52). Not a weekly charge. */
  annualWeeklyEquivalent: '$1.35',
  billingTerms:
    'No free trial. Payment is charged when you subscribe. Subscriptions renew automatically unless canceled in your Apple subscription settings.',
  checkoutNote:
    'There is no checkout on this website. Subscriptions are started and managed in the Lightning Learn iPhone app.',
  /** Child profiles included in one subscription. */
  maxProfiles: 3,
  /** Library size. */
  lessonCount: 160,
  worldCount: 16,
  /** Audience. Stated as an open-ended lower bound, never a range. */
  ageLabel: 'ages 7+',
} as const

export const maxProfilesWord = 'three'
